import { render, staticRenderFns } from "./DraftPriceCalculatedBox.vue?vue&type=template&id=1fd419ec&"
import script from "./DraftPriceCalculatedBox.vue?vue&type=script&lang=js&"
export * from "./DraftPriceCalculatedBox.vue?vue&type=script&lang=js&"
import style0 from "./DraftPriceCalculatedBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports